export default __webpack_public_path__ + "38666a0.png";